import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter } from 'react-router-dom';
import Home from './static/home';

// ReactDOM.render(<App />, document.getElementById('root'));
// registerServiceWorker();

ReactDOM.render((
  <BrowserRouter>
    <Home />
  </BrowserRouter>
), document.getElementById('root'))
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js